// extracted by mini-css-extract-plugin
export default {"main":"RequestStipend_main__kdYJf","banner":"RequestStipend_banner__ZippQ","imgContainer":"RequestStipend_imgContainer__zXg4P","img":"RequestStipend_img__f3OsB"};